/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
import { TrackTile, TrackTileProps } from '../track-tile';
import * as React from 'react';
import { PaddedCarousel } from './padded-carousel';
import { ArtistSchema, TrackSchema } from '../../types/schema';
import { classes, style } from 'typestyle';
import ArtistTileCompat, { ArtistTileCompatProps } from './artist-tile-compat';
import { TitledCarousel, TitledCarouselProps } from './titled-carousel';
import { FavouriteCTA } from './favourite-cta';

const DEFAULT_I18N = {
  availableFor: 'Available for',
};

export type FavouriteCarouselProps = Pick<TitledCarouselProps, 'hasBackground'> & {
  showOverlay?: boolean;
  overlayAction?: (event: React.MouseEvent<any>) => void;
};

export type FavouriteTracksCarouselProps = Omit<TrackTileProps, 'track'> &
  FavouriteCarouselProps & {
    tracks: TrackSchema[];
    i18n?: typeof DEFAULT_I18N;
  };

export type FavouriteArtistsCarouselProps = Omit<ArtistTileCompatProps, 'artist'> &
  FavouriteCarouselProps & { artists: ArtistSchema[] };

export const FavouriteTracksCarousel: React.SFC<FavouriteTracksCarouselProps> = ({
  hasBackground,
  showOverlay,
  overlayAction,
  tracks,
  i18n = DEFAULT_I18N,
  className,
  onClickLink,
  ...childProps
}) => {
  const tiles = tracks.map((track) => (
    <div key={track.identity} className={PaddedCarousel.styles.tileContainer}>
      <TrackTile
        track={track}
        onClickLink={onClickLink}
        {...childProps}
        className={classes(PaddedCarousel.styles.tile, className)}
      />
      {track.expires_at && (
        <div className={PaddedCarousel.styles.availability}>
          {i18n.availableFor} <span>{track.expires_at.text}</span>
        </div>
      )}
    </div>
  ));

  return (
    <TitledCarousel
      hasBackground={hasBackground}
      i18n={{ title: 'Favourite Tracks' }}
      href="/account/favourites"
      onClickLink={onClickLink}
    >
      <PaddedCarousel>{tiles}</PaddedCarousel>
      {showOverlay === true && <FavouriteCTA onClickLink={overlayAction} />}
    </TitledCarousel>
  );
};

export const FavouriteArtistsCarousel: React.SFC<FavouriteArtistsCarouselProps> = ({
  hasBackground,
  showOverlay,
  overlayAction,
  artists,
  className,
  onClickLink,
  ...childProps
}) => {
  const tiles = artists.map((artist) => (
    <div key={artist.identity} className={PaddedCarousel.styles.tileContainer}>
      <ArtistTileCompat
        artist={artist}
        onClickLink={onClickLink}
        {...childProps}
        className={classes(PaddedCarousel.styles.tile, className)}
      />
    </div>
  ));

  return (
    <TitledCarousel
      hasBackground={hasBackground}
      i18n={{ title: 'Favourite Artists' }}
      href="/account/favourites"
      onClickLink={onClickLink}
    >
      <PaddedCarousel>{tiles}</PaddedCarousel>
      {showOverlay === true && <FavouriteCTA onClickLink={overlayAction} />}
    </TitledCarousel>
  );
};
